import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Box, Checkbox, LoadingOverlay } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";

const GaransiTaggedComponent = ({
    stateData,
    fnOnChanged
}) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorChangeTaggedClientId: 'garansiSelected-2',
        errorChangeTaggedProjectId: 'garansiSelected-3',
        successChangeTagged: 'garansiSelected-4',
    })

    const [data, setData] = React.useState({
        isTaggedSubmitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const changeIsTaggedClientId = (val) => {
        setData(d => ({ ...d, isTaggedSubmitLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);

        formDT.append('tagged_client_id_is_checked', val);
        formDT.append('tagged_client_id', stateData.stock_garansi_client_id);

        formDT.append('garansi_id', stateData.stock_garansi_id);
        formDT.append('garansi_detil_id', stateData.stock_garansi_detil_id);
        formDT.append('garansi_item_status', stateData.garansiItemStatus);

        axios({
            method: 'post',
            url: BE_API_TWO + '/change_garansi_tagged_client_id',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, isTaggedSubmitLoading: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChanged(response.data.data);

                notifications.show({
                    id: notificationId.current.successChangeTagged,
                    title: utils.notification.success.caption,
                    message: 'Berhasil update data.',
                    color: utils.notification.success.color,
                    icon: utils.notification.success.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorChangeTaggedClientId,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan !',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, isTaggedSubmitLoading: false }));

            notifications.show({
                id: notificationId.current.errorChangeTaggedClientId,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: false,
            })
        })
    }

    const changeIsTaggedProjectId = (val) => {
        setData(d => ({ ...d, isTaggedSubmitLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);

        formDT.append('tagged_project_id_is_checked', val);
        formDT.append('tagged_client_id', stateData.stock_garansi_client_id);
        formDT.append('tagged_project_id', stateData.stock_garansi_project_id);

        formDT.append('garansi_id', stateData.stock_garansi_id);
        formDT.append('garansi_detil_id', stateData.stock_garansi_detil_id);
        formDT.append('garansi_item_status', stateData.garansiItemStatus);

        axios({
            method: 'post',
            url: BE_API_TWO + '/change_garansi_tagged_project_id',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, isTaggedSubmitLoading: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChanged(response.data.data);

                notifications.show({
                    id: notificationId.current.successChangeTagged,
                    title: utils.notification.success.caption,
                    message: 'Berhasil update data.',
                    color: utils.notification.success.color,
                    icon: utils.notification.success.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorChangeTaggedProjectId,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan !',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, isTaggedSubmitLoading: false }));

            notifications.show({
                id: notificationId.current.errorChangeTaggedProjectId,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: false,
            })
        })
    }

    return (
        <React.Fragment>
            <Box pos="relative">
                <LoadingOverlay visible={data.isTaggedSubmitLoading} overlayBlur={1} />

                <Checkbox
                    size='xs'
                    color="pink"
                    label={`Tag item ini untuk ${stateData.customer_name}`}
                    checked={stateData.isTaggedForClientId ? true : false}
                    onChange={(event) => {
                        changeIsTaggedClientId(event.target.checked);
                    }}
                    disabled={stateData.isTaggedForProjectId ? true : false}
                    mb='xs'

                    description={`Jika opsi ini dipilih, maka item ini akan dikhusukan untuk ${stateData.customer_name}`}
                />

                <Checkbox
                    size='xs'
                    color="pink"
                    label={`Tag item ini untuk nota ini`}
                    checked={stateData.isTaggedForProjectId ? true : false}
                    onChange={(event) => {
                        changeIsTaggedProjectId(event.target.checked);
                    }}
                    disabled={stateData.stock_garansi_reference === utils.garansiReference.project_pengerjaan_history.value}

                    description={`Jika opsi ini dipilih, maka item ini akan dikhusukan untuk ${stateData.customer_name} dan nota ini`}
                />
            </Box>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

        </React.Fragment>
    )
}

export default React.memo(GaransiTaggedComponent);